import { produce } from 'immer';
import { uuid } from '../../utils/utils';
import { ADD_COMMUNITY_CARDS_HISTORY_ENTRY, ADD_HAND_END_HISTORY_ENTRY, ADD_HOLE_CARDS_HISTORY_ENTRY, ADD_HTML_HISTORY_ENTRY, ADD_REVEALED_CARDS_HISTORY_ENTRY, ADD_SIDE_BETS_SUMMARY_HISTORY_ENTRY, ADD_TEXT_HISTORY_ENTRY, CLEAR_HISTORY_STATE } from '../actions/historyActions';
const initialState = {
    handHistoryEntries: []
};
const MAX_NUM_ENTRIES = 100;
function pruneEntries(handHistoryEntries) {
    if (handHistoryEntries.length > MAX_NUM_ENTRIES) {
        handHistoryEntries.splice(0, handHistoryEntries.length - MAX_NUM_ENTRIES);
    }
}
function addEntry(handHistoryEntries, handHistoryEntry) {
    handHistoryEntries.push(handHistoryEntry);
    pruneEntries(handHistoryEntries);
}
function getStreetNameFromBetRoundNumber(betRoundNumber) {
    switch (betRoundNumber) {
        case 1: {
            return 'Pre-flop';
        }
        case 2: {
            return 'Flop';
        }
        case 3: {
            return 'Turn';
        }
        case 4: {
            return 'River';
        }
        default: {
            console.warn(`Unrecognized bet round number ${betRoundNumber}`);
            return `Bet round ${betRoundNumber + 1}`;
        }
    }
}
const historyReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CLEAR_HISTORY_STATE: {
                return initialState;
            }
            case ADD_HOLE_CARDS_HISTORY_ENTRY: {
                const cards = action.payload;
                if (cards.length) {
                    addEntry(draft.handHistoryEntries, { type: 'hole-cards', uuid: uuid(), cards });
                }
                break;
            }
            case ADD_COMMUNITY_CARDS_HISTORY_ENTRY: {
                addEntry(draft.handHistoryEntries, {
                    type: 'community-cards',
                    uuid: uuid(),
                    cards: action.payload.cards,
                    streetName: getStreetNameFromBetRoundNumber(action.payload.newBetRoundNumber)
                });
                break;
            }
            case ADD_TEXT_HISTORY_ENTRY: {
                const { text, headerType } = action.payload;
                addEntry(draft.handHistoryEntries, {
                    type: 'text',
                    uuid: uuid(),
                    text,
                    headerType
                });
                break;
            }
            case ADD_HTML_HISTORY_ENTRY: {
                addEntry(draft.handHistoryEntries, {
                    type: 'html',
                    uuid: uuid(),
                    html: action.payload
                });
                break;
            }
            case ADD_REVEALED_CARDS_HISTORY_ENTRY: {
                const { cards, username } = action.payload;
                if (cards.length) {
                    addEntry(draft.handHistoryEntries, {
                        type: 'revealed-cards',
                        uuid: uuid(),
                        cards,
                        username: username
                    });
                }
                break;
            }
            case ADD_HAND_END_HISTORY_ENTRY: {
                addEntry(draft.handHistoryEntries, {
                    type: 'hand-end',
                    uuid: uuid()
                });
                break;
            }
            case ADD_SIDE_BETS_SUMMARY_HISTORY_ENTRY: {
                addEntry(draft.handHistoryEntries, {
                    type: 'side-bets-summary',
                    uuid: uuid(),
                    jacksWonPerWinner: action.payload.jacksWonPerWinner,
                    winners: action.payload.winners,
                    losers: action.payload.losers
                });
                break;
            }
        }
    });
};
export default historyReducer;
